module.exports = __webpack_public_path__ + "static/media/icon-confirmed.c805bd30.svg";